import { render } from "./DisableKeyModal.vue?vue&type=template&id=1c87ef2a&scoped=true&lang=pug"
import script from "./DisableKeyModal.vue?vue&type=script&lang=js"
export * from "./DisableKeyModal.vue?vue&type=script&lang=js"

import "./DisableKeyModal.vue?vue&type=style&index=0&id=1c87ef2a&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c87ef2a"]])

export default __exports__